export default {
  'acc102.cashProjection': '預計現金餘額',
  'acc102.cashTaxIncluded': '含稅現金餘額',
  'acc102.cashTaxExcluded': '未稅現金餘額',
  'acc102.cashReceivable': '預計売掛金（含稅）',
  'acc102.cashTaxReserve': '消費稅預留（概算）',
  'acc102.cashKnown': '已知現金餘額',
  'acc102.cashBaseline': '基準月底餘額',
  'acc102.cashRange': '推算期間',
  'acc102.cashOpening': '期初現金餘額',
  'acc102.cashMovement': '期間收支變動',
  'acc102.cashClosing': '期末現金餘額',
  'acc102.cashProjectionNotice':
    '含稅現金從2026年9月底3400萬起，按發票付款期限預計到帳；無期限按業務所屬月後2個月。未到預計到帳月的金額列為売掛金，不提前加入現金。稅金按業務所屬月預留（含未回款部分），未稅現金＝含稅現金－2026年1月起累計稅金預留。不抵扣進項稅或已繳稅，不拆分手動金額。僅為經營概算，非應納稅額或實際到帳記錄；基準前不反推。',
  'acc102.cashBeforeBaseline': '該期間早於已知基準，不反推現金餘額。',
  'acc102.cashOutOfRange': '超出預計現金餘額的推算範圍，請選擇較近期間。',
  'acc102.cashIncomplete': '有成本待核對月份，之後餘額暫時無法確定',
  'acc102.fixedExpenses': '固定支出',
  'acc102.fixedExpensesNotice':
    '2026年每個月按設定金額計入，並非實際付款記錄；不自動延續至其他年份。請勿手動重複登記。',
  'acc102.fixedExpenseAmount': '每月固定金額',
  'acc102.fixed.UR': 'UR',
  'acc102.fixed.UTILITIES': '光熱水電垃圾',
  'acc102.fixed.REPAYMENT_1': '還款1',
  'acc102.fixed.WITHHOLDING_TAX': '個人源泉所得稅',
  'acc102.fixed.LOCAL_TAX': '地方稅',
  'acc102.fixed.OFFICE': '事務所',
  'acc102.fixed.AWS': 'AWS',
  'acc102.fixed.TEAMS': 'Teams',
  'acc102.fixed.CODEX': 'Codex',
  'acc102.fixedFxNotice':
    '預算換算：{currency} {amount} × {rate} JPY/{currency}；參考日：{date}。四捨五入至日圓，非實際扣款，不額外加稅或手續費，不自動重算歷史匯率。',
  'acc102.estimated': '（預計）',
  'acc102.referenceMonth': '參考月份',
  'acc102.invoiceAuto': '發票收入（不含稅）',
  'acc102.invoiceAutoNotice':
    '採用營業部發票一覽的不含稅金額，按所屬月份計入，包含未開票預計；不改變原發票或收款，收款記錄不重複計入。請勿手動重複登記。',
  'acc102.commuteAuto': '交通費',
  'acc102.commuteAutoNotice':
    '按所屬月份計入全部通勤費申請（含未提交、待審批、已批准及退回）。僅整月沒有申請時，採用最近已結束且早於目標月的有資料月份，標註預計及參考月；已有申請不補齊。請勿手動重複登記。',
  'acc102.companyId': '公司ID',
  'acc102.applications': '申請筆數',
  'acc102.invoiceForecastAmount': '不含稅金額（含預計）',
  'acc102.commuteAmount': '申請金額',
  'acc102.manualStatus': '手動項目狀態',
  'acc102.salaryPeriodTotal': '本查詢期間已登記實付金額',
  'menu.accounting.income-expense': '損益對照',
  'acc102.pageTitle': '損益對照',
  'acc102.INCOME': '收入',
  'acc102.EXPENSE': '支出',
  'acc102.MANUAL': '手動',
  'acc102.INVOICE': '發票',
  'acc102.SALARY': '薪資',
  'acc102.DRAFT': '待補全',
  'acc102.CONFIRMED': '已登記',
  'acc102.VOID': '已作廢',
  'acc102.add': '新增手動項目',
  'acc102.edit': '編輯',
  'acc102.save': '儲存',
  'acc102.cancel': '取消',
  'acc102.confirm': '確認',
  'acc102.void': '作廢',
  'acc102.confirmPrompt': '確認為實際收支嗎？',
  'acc102.voidPrompt': '作廢此記錄嗎？將不再計入彙總。',
  'acc102.completeFirst': '請先儲存實際日期和金額。',
  'acc102.confirmedEdit': '編輯已確認記錄會立即更新實際收支彙總。',
  'acc102.direction': '收支方向',
  'acc102.title': '名稱',
  'acc102.targetMonth': '記錄顯示月份',
  'acc102.sourceMonth': '薪資所屬月份',
  'acc102.cashDate': '實際日期',
  'acc102.amount': '實際金額',
  'acc102.remarks': '備註',
  'acc102.status': '狀態',
  'acc102.actions': '操作',
  'acc102.baseSalary': '基本薪資（參考）',
  'acc102.allowance': '特別津貼（參考）',
  'acc102.missingReference': '薪資資料待確認，參考金額不會套入實際金額。',
  'acc102.required': '請填寫必填項。',
  'acc102.invalid': '請檢查輸入。金額為1至9,999,999,999,999的整數，日期不得晚於日本今天。',
  'acc102.empty': '沒有符合的記錄。',
  'acc102.emptyINCOME': '目前條件下尚無收入記錄',
  'acc102.emptyINCOMEHint':
    '發票一覽不含稅金額（含未開票預計）按所屬月份自動計入；其他收入可手動登記。',
  'acc102.emptyEXPENSE': '目前條件下尚無支出記錄',
  'acc102.emptyEXPENSEHint':
    '薪資公司總成本和全部通勤費申請按所屬月份自動計入；其他支出可手動登記。',
  'acc102.sourceNotice':
    '既有發票、薪資參考不會自動計入實收實付。選擇來源或手動登記，填完整實際日期、金額後儲存即計入統計，無需另行確認。',
  'acc102.saveNotice':
    '儲存後立即計入實際收支統計；發票收款會同步更新入金狀態，請核對實際日期和金額。',
  'acc102.saved': '操作成功。',
  'acc102.receipts': '收款明細',
  'acc102.addReceipt': '新增收款',
  'acc102.invoice': '發票編號',
  'acc102.company': '公司名稱',
  'acc102.invoiceAmount': '發票含稅金額',
  'acc102.received': '已登記收款',
  'acc102.remaining': '未收餘額',
  'acc102.billingMonth': '帳單月份',
  'acc102.reload': '重新載入',
  'acc102.invoiceSources': '從發票選擇',
  'acc102.history': '包含歷史已收發票',
  'acc102.legacyNotice':
    '首次儲存實際收款前保留舊收款狀態；儲存後由新帳本接管，後續作廢也不會恢復舊標記。',
  'acc102.salaryImport': '匯入薪資',
  'acc102.import': '匯入',
  'acc102.batchDate': '批次設定支付日期',
  'acc102.salaryNotice':
    '匯入僅建立薪資參考，實際金額和日期為空，不計統計。逐人補齊實際日期、金額後儲存即統計；重複匯入不覆蓋既有記錄。',
  'acc102.batchNotice':
    '只更新目前查詢結果中該所屬月待補全記錄的日期，不計入統計；補齊金額後逐人儲存。不更改已登記、作廢記錄或實際金額。',
  'acc102.cashNotice':
    '實際日期、金額填完整後儲存即統計，待補全記錄不計合計。本頁不替代概算或正式財務報表。',
  'acc102.month': '月度',
  'acc102.year': '年度',
  'acc102.allStatuses': '全部狀態',
  'acc102.selectedTotal': '所選月份收支',
  'acc102.annualTotal': '年度收支',
  'acc102.balance': '差額',
  'acc102.pending': '需核對數',
  'acc102.companyCost': '公司總成本',
  'acc102.companyCostNotice':
    '薪資按所屬月份引用会社総コスト，含公司保險見込和零收入10萬規則；發票和交通費也按所屬月份統計，僅手動項目按實際日期。請勿重複登記已含的公司負擔。',
  'acc102.automaticCost': '自動計入',
  'acc102.costReview': '成本待核對',
  'acc102.costBasis': '計算依據',
  'acc102.fixedCost': '零案件收入固定10萬',
  'acc102.standardCost': '標準成本',
  'acc102.accountId': '員工ID',
  'acc102.employee': '員工姓名',
  'acc102.employees': '人',
  'acc102.monthDetails': '12個月明細',
  'acc102.unpaid': '未收款',
  'acc102.partial': '部分收款',
  'acc102.paid': '已收款',
  'acc102.error.ACC102_INVALID': '輸入無效，請檢查金額、日期和目標月份。',
  'acc102.error.ACC102_NOT_FOUND': '未找到記錄，請保留輸入後重新載入。',
  'acc102.error.ACC102_CONFLICT': '記錄或請求存在衝突，請保留輸入並重新載入最新記錄。',
  'acc102.error.ACC102_OVERPAYMENT': '累計確認收款超過發票含稅金額，請檢查未收餘額。',
  'acc102.error.ACC102_SOURCE_CHANGED': '來源資料已改變，請保留輸入並重新核對來源。',
  'acc102.error.ACC102_LEGACY_DISABLED': '舊收款更新已停用，請重新整理後使用收款明細。',
  'acc102.error.forbidden': '沒有執行此操作的權限。',
  'acc102.error.unauthorized': '登入已過期，請重新登入。',
  'acc102.error.failed': '載入或操作失敗，輸入已保留，請檢查網路後重試。',
};
